import { gql } from "apollo-angular";

const GET_CROSS_REFERENCES_OPINION_OPTIONS = gql`
query CrossReferenceOpinionOptions{    
    crossReferenceOpinionOptions
    {
        optionKey
        opinion
        feedbackDescription
        feedback
    }        
}
`;

export default GET_CROSS_REFERENCES_OPINION_OPTIONS;